
export default {
	name: 'TriggerIcon',
};
